import React from 'react';
import get from 'lodash/get';
import {useTranslation} from "react-i18next";

import APIModel from "../../Components/APIModel";
import {store} from "../../configureStore";


const Products = (
    {
        match,
    }
) => {
    const {t, i18n} = useTranslation();

    const PRODUCTS_COLUMNS = [
        {
            name: t('catalog.products.columns.name', "Title"),
            cell: row => {
                if (!row.name) {
                    return '';
                }

                // let langByDefault = store.getState().Shops.activeShop.lang_by_default;
                // return String(row.name[langByDefault])
                return String(row.name)
            }
        },
        {
            name: t('catalog.products.columns.is_active', "Is active"),
            cell: row => <div>
                {row.is_active ? '✅' : '⏹'}
            </div>
        },
        {
            name: t('catalog.products.columns.image_url', 'Image'),
            cell: row => row.image_url ? <img
                src={row.image_url}
                style={{
                    maxWidth: '100%',
                    maxHeight: '60px',
                }}
            /> : '',
        },
        {
            name: t('catalog.products.columns.price', 'Price'),
             cell: row => <div>
                 {row.price.amount} {row.price.currency}
            </div>,
        },
        {
            name: t('catalog.products.columns.categories', 'Categories'),
            cell: row => {
                let langByDefault = store.getState().Shops.activeShop.lang_by_default;
                return get(row, 'categories', []).map((element, idx) => <div className='my-1' key={idx}>
                        <code className='text-secondary'>
                            {/*{element.name[langByDefault]}*/}
                            {element.name}
                        </code>
                    </div>
                );
            }
        },
        {
            name: t('catalog.products.columns.sort_order', 'Sort order'),
            selector: "sort_order",
        },
    ];

    return <APIModel
        heading={t('catalog.products.api_model.heading', 'Products')}
        subheading=''
        icon="pe-7s-bicycle icon-gradient bg-sunny-morning"
        apiPath='shop/products'
        tableColumns={PRODUCTS_COLUMNS}
        tableEmptyMessage={t('catalog.products.api_model.message_empty', 'No products')}
        hasFilters={true}
        match={match}
    />;
};

export default Products;
